<template>
    <div class="mr-snap-list">
        <div class="content">
            <div class="data">
                <div class="amount">{{ params.data }}</div>
                <div class="tendency" v-show="hasRecentSold">
                    <!--  more than the  0 -->
                    <div
                        class="up"
                        :class="[params.class ? params.class : '']"
                        v-if="params.status === 1 && !params.dataComing"
                    >
                        <span class="iconfont icon-trend-up"></span>
                        <span class="num">{{ params.changeNum }}</span>
                    </div>
                    <!--  less than  0 -->
                    <div
                        class="down"
                        :class="[params.class ? params.class : '']"
                        v-else-if="params.status === -1 && !params.dataComing"
                    >
                        <span class="iconfont icon-trend-down"></span>
                        <span class="num">{{ params.changeNum }}</span>
                    </div>
                    <!--  equal  0 -->
                    <div
                        class="no_data"
                        v-else-if="params.status === 0 && !params.dataComing"
                    >
                        <span>{{ params.changeNum }}</span>
                    </div>
                    <!-- 30-60 No listings sold during days  -->
                    <div class="no_data" v-else>
                        <span>{{ params.dataComing ? '' : '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="sort">{{ params.title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'snap-list',
    props: {
        params: Object,
        hasRecentSold: Boolean
    }
};
</script>

<style lang="scss">
.mr-snap-list {
    height: 144px;

    .content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 40px;
        .data {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 12px;
            justify-content: space-between;
            align-items: center;
        }
        .amount {
            font-family: var(--font-bold);
            font-size: 24px;
            color: var(--color-text);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .tendency {
            font-family: var(--font-bold);
            font-size: 18px;
            .up,
            .down {
                display: flex;
                align-items: center;
                justify-content: center;
                .iconfont {
                    margin-right: 2px;
                    font-size: 13px;
                }
            }
            .no_data {
                padding: 0;
                text-align: center;
            }
            .up {
                color: #25c44e;
                &.diff-color {
                    color: #ff3b3b;
                }
            }
            .down {
                color: #ff3b3b;
                &.diff-color {
                    color: #25c44e;
                }
            }
        }
    }

    .sort {
        font-family: var(--font-normal);
        font-size: 14px;
        font-weight: 500;
        color: var(--color-label);
        white-space: nowrap;
    }

    @media (max-width: 600px) {
        width: 222px;
        .content {
            padding: 0 26px;
        }
    }
}
</style>
